import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap';

@Component({
  selector: 'app-duplicate-name-confirm-modal',
  templateUrl: './duplicate-name-confirm-modal.component.html',
  styleUrls: ['./duplicate-name-confirm-modal.component.css']
})
export class DuplicateNameConfirmModalComponent {

    @ViewChild('confirmDuplicateName', { static: false }) confirmDuplicateNameModal: ModalDirective;
    private finishPromise = new Promise<void>(() => {
    });
    private resolveFinishPromise = () => {};

    constructor() {}

    public show() {
        setTimeout(() => {
            this.confirmDuplicateNameModal.show();
        }, 200);
    }

    public async showAwait() {
        this.finishPromise = new Promise<void>(resolve => this.resolveFinishPromise = resolve);
        this.confirmDuplicateNameModal.show();
        await this.finishPromise;
        return this.confirmed;
    }

    isEdit = false;
    public editMode() {
        this.isEdit = true;
    }

    confirmed: boolean;

    public confirm() {
        this.confirmed = true;
        this.confirmDuplicateNameModal.hide();
        this.resolveFinishPromise();
    }

    public discard() {
        this.confirmed = false;
        this.confirmDuplicateNameModal.hide();
        this.resolveFinishPromise();
    }


}
